module.exports = __webpack_public_path__ + "img/marido.banner.v5.f48f8eeb.png";